import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './LinkWidget.css';

const LinkWidget = ({ size, children, href, icon, withBouncing, ...rest }) => {
  const cx = classnames.bind(styles);
  const linkClasses = cx(
    'link',
    size,
    {'bouncing': withBouncing}
  );

  return (
    <a className={linkClasses} href={href} {...rest}>
      {children}
      {
        icon &&
          <Icon
            icon={icon.name}
            type={icon.type}
            customClasses={styles[`icon${size}`]}/>
      }
    </a>
  );
};

LinkWidget.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  icon: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.oneOf([
      '20',
      '30',
      'other'
    ])
  }),
  size: PropTypes.oneOf([
    'xs',
    's',
    'm',
    'l',
    'xl'
  ]),
  withBouncing: PropTypes.bool,
};

LinkWidget.defaultProps = { href: '#' };

LinkWidget.displayName = 'LinkWidget';

export default LinkWidget;



// WEBPACK FOOTER //
// ./src/uis/elements/Link/LinkWidget/LinkWidget.js